import { isDashboardFrame } from 'adapter/in/common/widget/widgetBuilder';
import { GridLayoutElement } from 'adapter/in/dashboards/components/generic/ReactGrid';
import Layout, { LayoutType } from 'domain/entity/layout';

export const mapLayoutWidgetsToGridElements = (layout: Layout, editingLayout: boolean | undefined): GridLayoutElement[] =>
    layout.widgets.map((widget) => ({
        i: widget.id,
        x: widget.position.x,
        y: widget.position.y,
        w: widget.size.width,
        h: widget.size.height,
        type: widget.type,
        maxHeight: widget.constraints.maxHeight,
        maxWidth: widget.constraints.maxWidth,
        minHeight: widget.constraints.minHeight,
        minWidth: widget.constraints.minWidth,
        static: !editingLayout || isDashboardFrame(widget.id, widget.type),
    }));

export const mapGridElementsToLayout = (gridElements: GridLayoutElement[], layoutType: LayoutType): Layout =>
    new Layout(
        layoutType,
        gridElements.map((el) => ({
            id: el.i,
            position: {
                x: el.x,
                y: el.y,
            },
            size: {
                width: el.w,
                height: el.h,
            },
            type: el.type,
            constraints: {
                maxHeight: el.maxHeight,
                maxWidth: el.maxWidth,
                minWidth: el.minWidth,
                minHeight: el.minHeight,
            },
        }))
    );
